import { Component, Input, OnInit } from '@angular/core';
import { LOOKUP } from 'src/app/models/common';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Subject } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-hlookups-add-multiple',
  templateUrl: './hlookups-add-multiple.component.html',
  styleUrls: ['./hlookups-add-multiple.component.scss']
})
export class HlookupsAddMultipleComponent implements OnInit {

  @Input() public Content: any;
  lookuptext: string = "";
  //content: any;
  //heading: string;
  action: Subject<any> = new Subject();
  IsParent: any;
  FirstLevelID: any;
  Module: any;
  addNewForm: UntypedFormGroup;
  isAllowNew: boolean = false;
  headValue: string;
  lookupListVal: LOOKUP;

  constructor(public modalRef: NgbActiveModal,
    public _modalRef: NgbActiveModal,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    this.addNewForm = new UntypedFormGroup(
      {
        SUPPORTVALUE: new UntypedFormControl("", [Validators.required, Validators.maxLength(50)]),
        STATUS: new UntypedFormControl(true)
      });

    if (this.Content.heading == "Edit") {
      this.isAllowNew = true;
      // this.addNewForm.controls['SUPPORTVALUE'].disable();
      this.addNewForm.patchValue({
        SUPPORTVALUE: this.Content.Name,
        STATUS: this.Content.RecordState
      });
    } else {
      this.Content.heading = "Add";
    }

    if (!this.Content.IsParent) {
      this.Content.headValue = "Sub-Values";
    } else {
      this.Content.headValue = "Supported Values";
    }
  }

  // save(): void {
  //   debugger;
  //   let lookuplist = [];
  //   let lookupstrings = this.lookuptext.split(',');
  //   for (let i = 0; i < lookupstrings.length; i++) {
  //     let text = lookupstrings[i].trim();
  //     if (text.length > 150) {
  //       this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Exceeds Lookup Maximum length 150' } } });
  //       return;
  //     }
  //     else if (text !== "" && text.length <= 150) {
  //       if (this.content.IsParent) {
  //         let lookup = new Object();
  //         lookup["LOOKUP_TYPE_ID"] = this.content.id;
  //         lookup["NAME"] = text;
  //         lookup["CODE"] = "PARENT";
  //         lookup["LANGUAGE_ID"] = this.content.Module;
  //         lookuplist.push(lookup);
  //       }
  //       else {
  //         let lookup = new Object();
  //         lookup["LOOKUP_TYPE_ID"] = this.content.id;
  //         lookup["NAME"] = text;
  //         lookup["CODE"] = "CHILD";
  //         lookup["DEFAULT_ID"] = this.content.FirstLevelID;
  //         lookuplist.push(lookup);
  //       }

  //     }
  //   }
  //   this.summaryService.insertHLookups(lookuplist).subscribe(summary => {
  //     if (summary.Status === 0) {
  //       this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Data has been inserted successfully.' } } });
  //       this.action.next();
  //       this.modalRef.hide();
  //     }
  //     else {
  //       this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: summary.Message } } });
  //     }

  //   });
  // }

  save(): void {
    let lookup: any;
    let text = this.addNewForm.controls['SUPPORTVALUE'].value;
    if (text != "") {
      if (text.length > 50) {
        this.commonService.ValidationBanner("Exceeds Lookup Maximum length 50");
        //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Exceeds Lookup Maximum length 50' } } });
        return;
      }
      else if (text !== "" && text.length <= 50) {
        if (this.Content.IsParent) {
          lookup = new Object();
          lookup["LOOKUP_TYPE_ID"] = this.Content.id;
          lookup["NAME"] = text;
          lookup["CODE"] = "PARENT";
          lookup["LANGUAGE_ID"] = this.Content.Module;
          lookup["ID"] = this.Content.FirstLevelID;
          lookup["RECORD_STATE"] = this.addNewForm.controls['STATUS'].value == true ? 1 : 0;
        }
        else {
          lookup = new Object();
          lookup["LOOKUP_TYPE_ID"] = this.Content.id;
          lookup["ID"] = this.Content.ID;
          lookup["NAME"] = text;
          lookup["CODE"] = "CHILD";
          lookup["DEFAULT_ID"] = this.Content.FirstLevelID == undefined ? this.Content.parentName : this.Content.FirstLevelID;
          lookup["RECORD_STATE"] = this.addNewForm.controls['STATUS'].value == true ? 1 : 0;
        }
      }

      if (!this.isAllowNew) {
        this.summaryService.insertHLookups(lookup).subscribe(summary => {
          if (summary.Status == 0) {
            let exist = true;
            if (this.Content.heading == "Add")
             {
              if(this.Content.IsParent)
              {
              lookup["ChildData"] = [];
              if (lookup.ID == null) {
                lookup.ID = this.commonService.getUniqueId();
              }
              if (this.Content.list.length > 0) {
                this.Content.list.forEach(element => {
                  let eleName: string = element.NAME;
                  let lkName: string = lookup.NAME;
                  if (eleName.toLowerCase() == lkName.toLowerCase()) {
                    this.commonService.ValidationBanner("The " + lookup.NAME + " already exists. Please update the details to save the value ");
                    //                    this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'The ' + lookup.NAME + ' already exists. Please update the details to save the value' } } });
                    exist = false;
                  }
                });
                if (exist) {
                  this.Content.list.push(lookup);
                  this.modalRef.dismiss();
                  //this.commonService.SuccessBanner(lookup.NAME + ' details inserted successfully');   
                }
              } 
              else {
                this.Content.list.push(lookup);
                this.modalRef.dismiss();
                //this.commonService.SuccessBanner(lookup.NAME + ' details inserted successfully');
              }
            }
            }
            else if (lookup.ID == null || lookup.ID == undefined) {
                lookup.ID = this.commonService.getUniqueId();
              }
              this.lookupListVal = this.Content.list.find(x => (x.NAME == lookup.DEFAULT_ID) || (x.ID == lookup.DEFAULT_ID));
              this.lookupListVal["ChildData"].forEach(element => {
                let eleName: string = element.NAME;
                let lkName: string = lookup.NAME;
                if (eleName.toLowerCase() == lkName.toLowerCase()) {
                  this.commonService.ValidationBanner("The " + lookup.NAME + " already exists. Please update the details to save the value ");
                  //               this.commonService.ValidationBanner('The ' + lookup.NAME + ' already exists. Please update the details to save the value' );
                  exist = false;
                }
              });
              if (exist) {
                this.lookupListVal["ChildData"].push(lookup);
                this.modalRef.dismiss();
                //this.commonService.SuccessBanner(lookup.NAME + ' details inserted successfully');
              }
          } else if (summary.ErrorCode == "DEFAULT006") {
            this.commonService.ValidationBanner(summary.Message);
            //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: summary.Message } } });
          } else {
            this.commonService.ErrorBanner(summary.Message);
          }
        });
      } else {
        if (this.Content.head == 'EditChild') {
          let exist: boolean = true;
          this.lookupListVal = this.Content.list.find(x => x.ID == this.Content.FirstLevelID);
          this.lookupListVal["ChildData"].forEach(element => {
            let eleName: string = element.NAME;
            let lkName: string = lookup.NAME;
            if (eleName.toLowerCase() == lkName.toLowerCase() && element.ID != lookup.ID) {
              this.commonService.ValidationBanner("The " + lookup.NAME + " already exists. Please update the details to save the value ");

              //  this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'The ' + lookup.NAME + ' already exists. Please update the details to save the value' } } });
              exist = false;
            }
          });

          let value = this.lookupListVal["ChildData"].find(x => x.NAME.toLowerCase() == lookup.NAME.toLowerCase() && x.RECORD_STATE == lookup.RECORD_STATE && x.ID == lookup.ID);
          if (value) {
            this.modalRef.dismiss();
            // this.commonService.ValidationBanner("No changes have been performed ");
            //  this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'No changes have been performed' } } });
          } else if (exist) {
            this.action.next(lookup);
            this.modalRef.close(lookup);
          }

        } else {
          let isExist = this.Content.list.find(x => x.NAME.toLowerCase() == lookup.NAME.toLowerCase() && x.ID != lookup.ID);
          if (isExist) {
            this.commonService.ValidationBanner("The " + lookup.NAME + " already exists. Please update the details to save the value ");
            // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'The ' + isExist.NAME + 'already exists. Please update the details to save the value' } } });
          } else if (this.Content.Name.toLowerCase() != lookup.NAME.toLowerCase() || this.Content.RecordState != lookup.RECORD_STATE) {
          //  this.action.next(lookup);
            this.modalRef.close(lookup);
          }
          else {
            this.modalRef.close();
            // this.commonService.ValidationBanner("No changes have been performed ");
            //  this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'No changes have been performed' } } });
          }
        }

      }
    } else {
      this.commonService.ValidationBanner("Please enter Supported Value");
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: 'Please fill mandatory fields' } } });
    }
  }

  close() {
    this.canExit().then((x) => {
      this._modalRef.dismiss();
    });

  }
  canExit() {
    if (this.addNewForm.dirty && this.Content.heading == "Edit") {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }
}
